// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3webp","list":"styles_list__x2WCU"};